<template>
  <div>
    
              <div class="font-weight-bolder font-size-h3 mb-8 col-6">
                Forum: {{ getTagInfo(forum.tag)}}
              </div>
           
    <div class="row justify-content-center">
      <div class=" col-4 sidebar">
        <div class="card">
          <div class="card-body">
            <div class="mb-10">
              <router-link to="/forums" class="">Forum</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="col-8 forum-single ">
       
           
            <div class="card" v-if="forum">
              <div class="card-header">
               <h2>{{forum.title}}</h2>
               <div class="d-flex ">
                <div class="date mr-5">
                <span class="text-muted">Asked:</span>  {{
                        forum.createdAt | moment("D MMM YYYY")
                      }}</div>
                       <div class="date mr-5">
                <span class="text-muted">Modified:</span> {{
                        forum.updatedAt | moment("D MMM YYYY")
                      }}</div>
                      <div class="views mr-5">
                     <span class="text-muted">Views:</span>  {{
                        forum.views
                      }}</div>
                <div class="tag mr-5">
                  <span class="text-muted">Tag:</span> 
                      {{ getTagInfo(forum.tag)}}
                     
                   </div>
               </div>
               
              </div>
              <div class="card-body">
                <div class="row align-items-center">
                  
                  <div class="col-12 col-md-2 text-center">
                    <div class="user " >
                      <img
                        class="rounded"
                         :src="getUserPhoto(forum.user)"
                       
                      />
                    </div>
                    <div class="username">
                      {{
                        getUserName(forum.user)
                      }}
                    </div>
                   
                  </div>
                  <div class="col-12 col-md-10">
                    <p class="text-muted ">
                      {{
                        forum.createdAt | moment("D MMM YYYY")
                      }}
                    </p>
                   
                    <div class="text-desc" v-html="forum.description"></div>
                    <div class="mt-10" v-if="forum.project">
                      <h4>Project related to this tutorial</h4>
                      <b-row>
                        <b-col md="4">
                          <router-link :to="'/projects/' + forum.project"
                            ><b-card class="p-5" no-body>
                              <b-row>
                                <b-col cols="3"
                                  ><img
                                    :src="
                                      'https://api.xupxup.net/public/uploads/projects/' +
                                        getProject(forum.project).image
                                    "
                                /></b-col>
                                <b-col>{{
                                  getProject(forum.project).title
                                }}</b-col>
                              </b-row>
                            </b-card>
                          </router-link>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h2
              class="font-weight-bolder font-size-h4 my-4"
              v-if="forum && forum.comments"
            >
              Replies ({{ forum.comments.length }})
              <span
                class="solve ml-3"
                @click="unsolve()"
                v-if="forumSolved && admin"
              >
                <button class="btn btn-danger btn-light btn-sm">
                  <i class="fa fa-thumbs-up"></i> Unmark as solved
                </button>
              </span>
            </h2>
            <div class="replies" v-if="forum && forum.comments.length > 0">
              <div
                class="card card-reply mb-2"
                v-for="r in forum.comments"
                :class="{ solved: r.isSolved }"
                :key="r._id"
              >
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col-12 col-md-2  text-center">
                      <div class="user">
                        <img
                          class="rounded"
                          :src="getUserPhoto(r.user)"
                        />
                      </div>
                      <div>
                        <div class="username"
                          >{{ getUserName(r.user) }}</div
                        >
                      </div>
                    </div>
                    <div class="col-12 col-md-9">
                      
                      <div v-html="r.text" class="border-bottom mb-3"></div>
                      <p class="mb-1">
                       <span class="text-muted">Modified:</span> {{ r.updatedAt | moment("D MMM YYYY") }}
                      </p>
                      <div class="likes mt-3">
                        <span
                          class="btn label label-light label-inline px-5 py-4"
                          :class="{ liked: checkLike(r, me) }"
                          @click="like(r._id, me)"
                        >
                          <i class="fa fa-heart mr-3"></i> {{ r.likes.length }}
                          <span class="ml-3 thanks" v-if="checkLike(r, me)"
                            ><b>Thanks!</b></span
                          >
                        </span>
                        <span
                          class="solve ml-3"
                          @click="solve(r)"
                          v-if="!forumSolved"
                        >
                          <button class="btn btn-danger btn-light btn-sm">
                            <i class="fa fa-thumbs-up"></i> Mark as solution
                          </button>
                          
                        </span>
                         <span
                        class="remove ml-3"
                        v-if="checkAdmin(roles, me)"
                        @click="remove(r._id)"
                      >
                        <button class="btn btn-sm"><i class="fa fa-trash"></i> Delete</button>
                      </span>
                      </div>
                    </div>
                    
                  </div>
                  <div class="solved-icon" v-if="r.isSolved">
                    <p>SOLVED</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="no-comments" v-else>
              <p>There is no comments in this post.</p>
            </div>
            <div
              class="reply mt-5"
              v-if="forum && isSolved(forum.comments).length == 0"
            >
              <p>Do you want to reply?</p>
              <b-form v-on:submit.prevent="sendReply(me, $event)">
                <!-- <textarea
                  v-model="form.text"
                  type="text"
                  class="form-control form-control-lg"
                  ref="text"
                  name="text"
                  placeholder="Reply text"
                ></textarea> -->
                <vue-editor
                  id="textarea2"
                  :editor-toolbar="customToolbar"
                  v-model="form.text"
                ></vue-editor>
                <input
                  type="submit"
                  value="Publish"
                  class="btn mt-2 btn-info"
                />
              </b-form>
            </div>
          </div>
   
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import "@/core/plugins/collapse";
import axios from "axios";

export default {
  name: "forum-single",
  components: {},
  data() {
    return {
      series: [],
      form: {},
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote", "code-block"],
        [{ indent: "-1" }, { indent: "+1" }],
        ["link", "clean"]
      ]
    };
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Forum",
        subtitle: this.$store.getters.getForums.find(
          f => f._id === this.$route.params.forumId
        ).title
      }
    ]);
    axios.put("forum/" + this.forum._id + "/view").then(response => {
      console.log("response", response);
      this.$store.dispatch("fetchForums");
    });
  },
  methods: {
    getProject(project) {
      return this.projects.find(p => project === p._id);
    },
    checkAdmin(roles, user) {
      console.log("roles", roles, user);
      let admin = roles.find(r => r.name === "admin");
      let isAdmin = admin ? user.roles.includes(admin._id) : null;
      return isAdmin;
    },
    getUserName(u) {
      let username = this.users.find(user => user._id == u);
      return username?.firstName + " " + username?.lastName;
    },
    getTagInfo(t) {
      let tag = this.tags.find(tag => tag._id == t);
      return tag?.name;
    },
    getUserPhoto(u) {
      let avatar = this.users.find(user => user._id == u).avatar;
      return avatar
        ? process.env.VUE_APP_API_URL + avatar
        : "/media/svg/avatars/001-boy.svg";
    },
    isSolved(c) {
      // console.log(c.filter(i => i.isSolved));
      return c.filter(i => i.isSolved);
    },
    checkLike(comment, user) {
      //console.log("check", comment, user._id, comment.likes.includes(user));
      return comment.likes.includes(user._id);
    },
    like(comment, user) {
      console.log(comment, user);
      let f = this.forum.comments.find(c => c._id === comment);
      if (!f.likes.includes(user._id)) {
        f.likes.push(user._id);
      } else {
        const index = f.likes.indexOf(user._id);
        console.log(index);
        f.likes.splice(index, 1);
      }
      axios.put("forum/" + this.forum._id, this.forum).then(response => {
        console.log("response", response);
        this.$store.dispatch("fetchForums");
      });
    },
    remove(c) {
      let index = this.forum.comments.findIndex(co => co._id == c);
      this.forum.comments.splice(index, 1);
      axios.put("forum/" + this.forum._id, this.forum).then(response => {
        console.log("response", response);
        this.$store.dispatch("fetchForums");
      });
    },
    solve(c) {
      let author = this.forum.user == this.me._id ? true : false;
      if (author || this.admin) {
        let index = this.forum.comments.findIndex(co => co._id == c._id);
        this.forum.comments[index].isSolved = true;
        axios.put("forum/" + this.forum._id, this.forum).then(response => {
          console.log("response", response);
          this.$store.dispatch("fetchForums");
        });
      }
      return author;
    },
    unsolve() {
      let index = this.forum.comments.findIndex(co => co.isSolved);
      this.forum.comments[index].isSolved = false;
      axios.put("forum/" + this.forum._id, this.forum).then(response => {
        console.log("response", response);
        this.$store.dispatch("fetchForums");
      });
    },
    sendReply(user, event) {
      this.form.user = user._id;
      console.log("form", user, event, this.form);
      axios
        .put("forum/" + this.forum._id + "/comment", { comments: this.form })
        .then(response => {
          console.log("response", response);
          this.$store.dispatch("fetchForums");
          this.form = {};
        });
    }
  },
  computed: {
    me() {
      return this.$store.getters.getMyUser;
    },
    admin() {
      let roles = this.$store.getters.getRoles.find(
        r => r.name === "admin" || r.name === "teacher"
      );

      let isAdmin = roles
        ? this.$store.getters.getMyUser.roles.includes(roles._id)
        : null;
      return isAdmin;
    },
    roles() {
      return this.$store.getters.getRoles;
    },
    forum() {
      return this.$store.getters.getForums.find(
        f => f._id === this.$route.params.forumId
      );
    },
    forumSolved() {
      let forum = this.$store.getters.getForums.find(
        f => f._id === this.$route.params.forumId
      );
      return forum.comments.filter(s => s.isSolved).length > 0 ? true : false;
    },
    users() {
      return this.$store.getters.getUsers;
    },
    tags() {
      return this.$store.getters.getTags;
    },
    levels() {
      return this.$store.getters.getLevels;
    },
    profiles() {
      return this.$store.getters.getProfiles;
    },
    projects() {
      return this.$store.getters.getProjects;
    },
    ...mapGetters(["currentUser"])
  }
};
</script>

<style lang="scss">
.forum-single {
  h3 {
    border-bottom: 1px solid gray;
    padding: 5px 0;
    margin-bottom: 20px;
  }
  .tags {
    position: absolute;
    top: -10px;
    left: 20px;
  }
  .user {
    width: 100%;
    max-width: 75px;
    max-height: 75px;
    border-radius: 100px;
    display: inline-block;
    background: rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }
  .user img {
    width: 100%;
  }
  .username {
    font-size: 12px;
    font-weight: 500;
    margin: 5px 0;
  }

  .replies .solved {
    background-color: rgb(147, 250, 165);
  }
  .card-reply {
    overflow: hidden;
  }
  .remove button {
    border: 1px solid #f14850;
    color: #f14850;
    margin: 0;
    text-align: center;
  }
  .remove button:hover {
    border: 1px solid #f14850;
    background-color: #f14850;
    color:white;
    margin: 0;
    text-align: center;
  }
  .remove i {
    color: #f14850;
  }
  .remove button:hover i{
    color:white;
  }
  .solved-icon {
    position: absolute;
    top: 20px;
    right: -42px;
    width: 150px;
    transform: rotate(45deg);
    text-align: center;
    border-top: 3px solid white;
    border-bottom: 3px solid white;
    padding: 3px;
    color: white;
    font-weight: 800;
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  }
  .solved-icon p {
    margin: 0;
  }
  .text-desc {
    a {
      color: #3498db;
    }
  }
  .likes {
    .label {
      background: transparent;
      border: 1px solid rgba(0, 0, 0, 0.2);
    }
    .label.liked {
      background: transparent;
      border: 1px solid #2ecc71;
      background: #2ecc71;
      color: black;
      i {
        color: black;
      }
      .thanks {
        color: black;
      }
    }
  }
  .ql-toolbar {
    background: rgb(249, 249, 249);
  }
  #textarea2 {
    background: white;
  }
  pre {
    background: rgb(25, 25, 25);
    color: antiquewhite;
    padding: 10px;
    white-space: pre-wrap;
    font-family: monospace;
    tab-size: 2;
    border-radius: 3px;
  }
  .ql-indent-1 {
    text-indent: 25px;
  }
  .ql-indent-2 {
    text-indent: 45px;
  }
  a {
    color: #3498db;
  }
}
</style>
